export const environment = {
  production: true,
  languages: ['en', 'fr', 'id', 'de', 'it', 'es', 'ar', 'el'],
  defaultLang: 'en',
  title: '4D',
  favicon: '/static/images/favicon/4Dfav.ico',
  ws: {
    key: 'app-key',
    enabledTransports: ['wss'],
    authEndpoint: '/broadcasting/auth',
  },
  recaptcha: {
    siteKey: '6LfWgfsqAAAAAKxQRXHffiz2ifE9cS5X5j-bazvK',
  },
};
